<h2>Multiple Addresses</h2>

  <div class="horizontal-scroller vertical-scroller tableDiv">
    <table 
        mat-table
        [dataSource]="dataSource"
        matSort
        class="noselect tenders-grid dialog-table"
        multiTemplateDataRows
      >
      <ng-container matColumnDef="utilityAccountNumber">
        <th class="multipleAddressHeaders" mat-header-cell *matHeaderCellDef mat-sort-header>Utility Account Number</th>
        <td mat-cell *matCellDef="let address">
          {{ address.utilityAccountNumber }}
        </td>
      </ng-container>

      <ng-container matColumnDef="zipCode">
        <th class="multipleAddressHeaders" mat-header-cell *matHeaderCellDef mat-sort-header>Zip Code</th>
        <td mat-cell *matCellDef="let address; let i = index">
          <input type="text" maxlength="5" [(ngModel)]="address.zipCode" #zipCodeInput="ngModel" (ngModelChange)="onZipCodeChange(address.zipCode, address)">
          <mat-error *ngIf="!address.isZipCodeValid">
            <small>Please enter a valid zip code.</small>
          </mat-error>
        </td>
      </ng-container>

      <ng-container matColumnDef="validation">
        <th class="multipleAddressHeaders" mat-header-cell *matHeaderCellDef mat-sort-header></th>
        <td mat-cell *matCellDef="let address; let i = index">
          <mat-spinner matSuffix [diameter]="16" *ngIf="address.isZipCodeLoading" color="primary" [matTooltip]="'Fetching zipcode data.'"></mat-spinner>
        </td>
      </ng-container>

      <ng-container matColumnDef="city">
          <th class="multipleAddressHeaders" mat-header-cell *matHeaderCellDef mat-sort-header>City</th>
          <td mat-cell *matCellDef="let address; let i = index">
            {{ address.city }}
          </td>
      </ng-container>

      <ng-container matColumnDef="state">
        <th class="multipleAddressHeaders" mat-header-cell *matHeaderCellDef mat-sort-header>State</th>
        <td mat-cell *matCellDef="let address; let i = index">
          {{ address.state }}
        </td>
      </ng-container>

      <ng-container matColumnDef="addressLine1">
        <th class="multipleAddressHeaders" mat-header-cell *matHeaderCellDef mat-sort-header>Address Line 1</th>
        <td mat-cell *matCellDef="let address; let i = index">
          <input type="text" [(ngModel)]="address.addressLine1" (keyup)="validateAddressLine1(address)">
          <mat-error *ngIf="!address.isAddressLine1Valid">
            <small>Please enter Address Line 1.</small>
          </mat-error>
        </td>
      </ng-container>

      <ng-container matColumnDef="addressLine2">
        <th class="multipleAddressHeaders" mat-header-cell *matHeaderCellDef mat-sort-header>Address Line 2</th>
        <td mat-cell *matCellDef="let address; let i = index">
          <input type="text" [(ngModel)]="address.addressLine2">
        </td>
      </ng-container>
      
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let element; columns: displayedColumns"></tr>
    </table>
  </div>

  <div class="fullWidthSolo">
    <div class="rightSolo">
      <button id="multipleAddressSaveBtn" mat-raised-button color="accent" (click)="save()" [disabled]="!isFormValidForSave()">Save</button>
      <button id="multipleAddressCloseBtn" mat-flat-button color="secondary" type="button" (click)="closeMultipleAddressDialogRef()">Close</button>
    </div>
  </div>
